import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Select from "react-select";
import AgGridTable from "../utilities/AgGridTable";
import { TourRecoContext } from "./Logistic";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import EmailPreview from "./EmailPreview";
import moment from "moment";

let weekOption = [];
for (let i = 1; i <= 52; i++) {
  weekOption.push({ label: i });
}


const EmailPreviewContext = createContext();

const TourReco = () => {
  const [tourReco, setTourReco] = useContext(TourRecoContext);

  const containersUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containers}`;
  const getReconciliationUrl =`${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getReconciliationReport}`;
  const emailPreviewUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.emailPreview}`;

  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectWeek, setSelectWeek] = useState("");
  const [emailPreviewDialog, setEmailPreviewDialog] = useState(false);
  const [emailPreHtml, setEmailPreHtml] = useState("")

  const [columnDefs, setColumnDefs] = useState([
    // { field: "snNo", enableRowGroup: true, headerTooltip: "Sn No" },
    { field: "plannedLoadingWeek", enableRowGroup: true, headerTooltip: "Planned Loading Week" },
    { field: "abNumber", enableRowGroup: true, headerTooltip: "Order Ref" },
    {
      field: "containerNo",
      enableRowGroup: true,
      headerTooltip: "Customer No",
      headerName: "Internal Container Number"
    },
    {
      field: "tourNo",
      enableRowGroup: true,
      headerTooltip: "Tour No",
      // cellRenderer: TourNo,
    },
    {
      field: "actualContainerNumber",
      enableRowGroup: true,
    },
    {
      field: "loadingDate",
      enableRowGroup: true,
      headerName: "Tour Planning Date",
      headerTooltip: "Tour Planning Date",
      cellRenderer: handleDateFormat,
    },
    {
      field: "foundInOrders",
      enableRowGroup: true,
      headerTooltip: "Order In NOS",
      cellRenderer: OrderInNOS,
    },
    {
      field: "foundInPL",
      enableRowGroup: true,
      headerName: "Order in Packing List",
      headerTooltip: "Order in Packing List",
      cellRenderer: OrderList,
    },
  ]);

  /*------------------- cell renderer function------------------------------- */

  function handleDateFormat (props) {
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  // function TourNo(props) {
  //   if (props?.data?.tourNo === "") {
  //     return (
  //       <p className="text-center">
  //         <CancelIcon fontSize="small" color="error" />
  //       </p>
  //     );
  //   } else {
  //     return <p className="text-center">{props.value}</p>;
  //   }
  // }

  function OrderInNOS(props) {
    if (props?.data?.foundInOrders === true) {
      return (
        <p className="text-center">
          <CheckCircleIcon fontSize="small" color="success" />
        </p>
      );
    } else {
      return (
        <p className="text-center">
          <CancelIcon fontSize="small" color="error" />
        </p>
      );
    }
  }

  function OrderList(props) {
    if (props?.data?.foundInPL === true) {
      return (
        <p className="text-center">
          <CheckCircleIcon fontSize="small" color="success" />
        </p>
      );
    } else {
      return (
        <p className="text-center">
          <CancelIcon fontSize="small" color="error" />
        </p>
      );
    }
  }

  /*--------------------------------------------------------------------- */


  const autoSizeAll = useCallback(
    (value) => {
      const allColumnIds = [];
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
    },
    [rowData]
  );

  const onGridReady = useCallback((params) => {
    // setGridApi(params);
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
    autoSizeAll(false);
  }, []);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const handleWeekSelect = (data) => {
    setSelectWeek(data.label);
  };

  const getTourReco = async () => {
    let loadingYear = new Date().getFullYear();
    const containers = await OAuthService.getList(`${getReconciliationUrl}/${loadingYear}/${selectWeek}`);
    setRowData(containers.data);
  };

  const handleSubmit = async()=>{
    const model ={
      containerId : "",
      loadingYear: "",
      loadingWeek: "",
    } 
    const emailPreview = await OAuthService.addData(emailPreviewUrl, model);
    console.log('emailPreview.data', emailPreview.data)
    setEmailPreHtml(emailPreview.data);
    setEmailPreviewDialog(true);
  }
  useEffect(() => {
    if (selectWeek) {
      getTourReco();
    }
  }, [selectWeek]);

  return (
    <>
      <Dialog
        open={tourReco}
        onClose={() => setTourReco(false)}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Tour Planning Reco</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={() => setTourReco(false)}>
                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContent>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-between space-x-8 mb-10">
              <Stack>
                <label>Select TPW</label>
                <Select
                  className="mb-16 w-[120px]"
                  name="selectWeek"
                  value={
                    selectWeek &&
                    weekOption &&
                    weekOption.filter((obj) => selectWeek === obj.label)
                  }
                  options={weekOption}
                  onChange={handleWeekSelect}
                  styles={customStyles()}
                />
              </Stack>
              <Button
                variant="contained"
                color="warning"
                onClick={() => {
                  handleSubmit()
                  // setEmailPreviewDialog(true)
                  // setShowInvoice(true);
                  //   navigate("/logistics");
                }}
                disabled={selectedRows.length > 0 ? false : true}
              >
                Preview
              </Button>
            </div>

            <div className="h-[400px]">
              <AgGridTable
                rowData={rowData}
                gridRef={gridRef}
                columnDefs={columnDefs}
                onSelectionChanged={onSelectionChanged}
                editable={false}
                rowSelection={'single'}
                groupCheckBox={false}
                hideCheckbox={true}
                // editType={"fullRow"}
                // getContextMenuItems={getContextMenuItems}
                onGridReady={onGridReady}
              />
            </div>
          </DialogContent>
        </DialogContent>
      </Dialog>
      <EmailPreviewContext.Provider
        value={[
          emailPreviewDialog,
          setEmailPreviewDialog
        ]}
      >
        <EmailPreview emailPreHtml={emailPreHtml} setEmailPreHtml={setEmailPreHtml} />
      </EmailPreviewContext.Provider>
    </>
  );
};

export default TourReco;
export { EmailPreviewContext };
